import React, { useState, useEffect } from "react";
import DepositWithdrawSuccessMsg from "../common/DepositWithdrawSuccessMsg";
import { handleDepositAPI, setDepositRes } from "./cl_payment";
import { useDispatch, useSelector } from "react-redux";
import { paymentConfig } from "../signIn/cl_SignInSlice";
import icons from "../../assets/images/sprite-other-icons.svg";
import { useNavigate } from "react-router-dom";
import { trackDepositEvent } from "../../service/gtag";

function Deposit() {
  const [depositAmount, setDepositAmount] = useState("500");
  const { depositResponse, loader } = useSelector((state) => state.payment);
  const { userDetails } = useSelector((state) => state?.signIn);
  const { accountDetailsData } = useSelector((state) => state?.accountDetails);
  const userEmail = accountDetailsData?.userOtherInfo?.email;
  const countryCode = accountDetailsData?.userOtherInfo?.country;
  const userSystemTags = userDetails?.userSystemTags || "";
  const [userType, setUserType] = useState(" ");
  const maxLimit = 50000;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const hasDepositHistory = userSystemTags.includes("deposit_yes");
    setUserType(hasDepositHistory ? "returning" : "new");
  }, [userSystemTags]);

  const handleSwitch = (amount) => {
    setDepositAmount(amount);
  };

  const re = /^[0-9]+$/;

  function avoidCharacter(e) {
    if (!re.test(e.key)) {
      e.persist();
      e.preventDefault();
    }
  }

  const handleInput = (e) => {
    const value = e.target.value;
    dispatch(setDepositRes(""));
    if (/^\d*$/.test(value) || value === "") {
      setDepositAmount(value);
    }
  };

  useEffect(() => {
    dispatch(paymentConfig());
  }, [dispatch]);

  useEffect(() => {
    dispatch(setDepositRes(""));
  }, [dispatch]);

  useEffect(() => {
    if (depositResponse === "Deposit request placed successfully") {
      const timer = setTimeout(() => {
        navigate("/");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [depositResponse, navigate]);

  const handleValidation = (e) => {
    const allowedKeys = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57];
    const allowedKeyPadKeys = [96, 97, 98, 99, 100, 101, 102, 103, 104, 105];
    if (
      allowedKeys.indexOf(e.keyCode) === -1 &&
      allowedKeyPadKeys.indexOf(e.keyCode) === -1 &&
      e.keyCode !== 8
    ) {
      e.preventDefault();
    }
  };

  const handleDeposit = async () => {
    if (loader) return;

    if (depositAmount >= 10 && depositAmount <= maxLimit) {
      const userNumber =
        userDetails.countryCode + "" + userDetails.userOtherInfo.phone;
      const currency = userDetails?.userOtherInfo?.currency || "KES";

      const isFirstDeposit = userSystemTags.includes("deposit_first");
      const hasDepositHistory = userSystemTags.includes("deposit_yes");
      const currentUserType = hasDepositHistory ? "returning" : "new";

      setUserType(currentUserType);

      function getGtagClientAndSession() {
        const gaCookie = document.cookie.split('; ').find(c => c.startsWith('_ga='));
        const ga4Cookie = document.cookie.split('; ').find(c => c.startsWith('_ga_'));

        let clientId = null;
        let sessionId = null;

        if (gaCookie) {
          const parts = gaCookie.split('.');
          clientId = parts[parts.length - 1];
        }

        // if (ga4Cookie) {
        //   const parts = ga4Cookie.split('.');
        //   sessionId = parts[2]; // timestamp = session start
        // }

        sessionId = Number(localStorage.getItem('sessionId'));

        return { clientId, sessionId };
      }

      let { clientId, sessionId } = getGtagClientAndSession();


      dispatch(
        handleDepositAPI(
          depositAmount,
          userNumber,
          userDetails.userId,
          userEmail,
          countryCode,
          clientId,
          sessionId,
          userSystemTags,
          currency,
          currentUserType
        )
      ).then(({status, res}) => {
        if (status === "success") {
          trackDepositEvent(
            res?.result?.data?.transactionDetails?.transactionId,
            userDetails.userOtherInfo.phone,
            depositAmount,
            currency,
            currentUserType,
            isFirstDeposit
          );
        }
      });
    } else {
      dispatch(setDepositRes(`Please enter value between 10 to ${maxLimit}`));
    }
  };

  const goBack = () => {
    navigate("/");
  };

  return (
    <React.Fragment>
      <div className="SB-page-content">
        <div id="page-myAccountMenu" className="SB-myAccountSideMenu">
          <div className="SB-myAccountMenu-container">
            <div className="SB-myAccountMenu-close-container">
              <div
                className="SB-myAccountMenu-closeButton"
                id="SB-myAccountMenu-closeButton"
              >
                Close{" "}
                <div className="SB-iconSVG">
                  <svg xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref="images/sprite-other-icons.svg#icon-close"></use>
                  </svg>
                </div>
              </div>
            </div>
            {/* Rest of the menu content */}
          </div>
        </div>
        <div className="SB-myAccountSection-container SB-deposit">
          <div className="SB-pageHeader">
            <div className="SB-pageBackButton">
              <div className="SB-iconSVG" onClick={goBack}>
                <svg xmlns="http://www.w3.org/2000/svg">
                  <use xlinkHref={`${icons}#${"icon-back"}`} />
                </svg>
              </div>
            </div>
            <div className="SB-pageHeader-title">Deposit</div>
          </div>

          {!depositResponse ||
            depositResponse !== "Deposit request placed successfully" ? (
            <div id="SB-deposit-chooseMethod">
              <div className="SB-content">
                <div className="SB-payBill">
                  <p>
                    MPESA Paybill: <span>4999936</span>
                  </p>
                </div>
                <div className="SB-form-group">
                  <div className="SB-form-label">
                    Enter Amount{" "}
                    <span className="SB-amountMinMax">
                      (Min KES 10 - Max KES {maxLimit})
                    </span>
                  </div>
                  <div className="SB-form-control-group SB-mobileNumberField">
                    <div className="SB-form-addon SB-addon-left">
                      <div className="SB-regionCode">KES</div>
                    </div>
                    <div className="SB-form-control">
                      <input
                        type="tel"
                        placeholder="Enter Amount Here"
                        className="SB-inputAddon"
                        value={depositAmount}
                        onChange={handleInput}
                        onKeyPress={avoidCharacter}
                        onKeyDown={handleValidation}
                        maxLength={10}
                      />
                    </div>
                  </div>
                </div>
                <div className="SB-chooseAmount">
                  <div className="SB-chooseAmountList">
                    <ul>
                      <li onClick={() => handleSwitch("100")}>
                        <div
                          className={
                            depositAmount === "100"
                              ? "SB-chooseAmountList-item active"
                              : "SB-chooseAmountList-item"
                          }
                        >
                          100
                        </div>
                      </li>
                      <li onClick={() => handleSwitch("500")}>
                        <div
                          className={
                            depositAmount === "500"
                              ? "SB-chooseAmountList-item active"
                              : "SB-chooseAmountList-item"
                          }
                        >
                          500
                        </div>
                      </li>
                      <li onClick={() => handleSwitch("1000")}>
                        <div
                          className={
                            depositAmount === "1000"
                              ? "SB-chooseAmountList-item active"
                              : "SB-chooseAmountList-item"
                          }
                        >
                          1,000
                        </div>
                      </li>
                      <li onClick={() => handleSwitch("2000")}>
                        <div
                          className={
                            depositAmount === "2000"
                              ? "SB-chooseAmountList-item active"
                              : "SB-chooseAmountList-item"
                          }
                        >
                          2,000
                        </div>
                      </li>
                    </ul>
                  </div>
                  {depositResponse &&
                    depositResponse !==
                    "Deposit request placed successfully" && (
                      <div className="SB-form-errorMsg">{depositResponse}</div>
                    )}
                </div>
                <div className="SB-space10"></div>
                <button
                  className="btn SB-btnSecondary SB-btnLarge active"
                  id="SB-btn-Deposit"
                  onClick={handleDeposit}
                >
                  <div className="SB-btnTxt">{loader ? "" : "Deposit"}</div>
                  <div
                    className={`SB-loader-container ${loader ? "" : "d-none"}`}
                  >
                    <div className="SB-loader"></div>
                  </div>
                </button>
                <div className="SB-paymentMethod-help">
                  <div className="text-center">
                    <p>
                      Helpline:{" "}
                      <a href="tel:254709515000">
                        <b>+254705065203</b>
                      </a>
                    </p>
                    <p>
                      Email:{" "}
                      <a href="mailto:helpke@fasfas.com">
                        <b>support.ke@fasfasgames.com</b>
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div id="SB-deposit-success" style={{ display: "block" }}>
              <DepositWithdrawSuccessMsg message={"deposit"} />
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

export default Deposit;
